import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const AUTH_WATCHER_FOOTER_FOOTER_ACTION_PROPS = {
    variant: VARIANTS.FooterVariantsType.ONE_ACTION,
  },
  AUTH_WATCHER_FOOTER_FOOTER_ACTION_LINK_PROPS = {
    type: VARIANTS.ButtonVariantType.PRIMARY,
    size: VARIANTS.ButtonSizeType.LARGE,
  };

export { AUTH_WATCHER_FOOTER_FOOTER_ACTION_PROPS, AUTH_WATCHER_FOOTER_FOOTER_ACTION_LINK_PROPS };
